// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TWebChatsSyncRequest, TWebChatsSyncModel, IMappers, TWebChatsSyncResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IIncrSyncAppsResponseSchema } from '../../../../entities/synchronization/IncrSyncAppsResponseSchema';
import type { IErrorResponseSchema } from '../../../../entities/schemas/ErrorResponseSchema';

export function createWebChatsSyncModel(parameters: TWebChatsSyncRequest): TWebChatsSyncModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'chats',
    pathApi: '/v2/web/chats/sync/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IWebChatsSyncOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TWebChatsSyncRequest;
}

export async function fetchWebChatsSync<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IWebChatsSyncOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TWebChatsSyncResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createWebChatsSyncModel(parameters),
    config,
  )) as FetchResponse<TWebChatsSyncResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IIncrSyncAppsResponseSchema, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TWebChatsSyncResponse>;
}
